import { render, staticRenderFns } from "./moretopics.vue?vue&type=template&id=0a8a4820&scoped=true"
import script from "./moretopics.vue?vue&type=script&lang=js"
export * from "./moretopics.vue?vue&type=script&lang=js"
import style0 from "./moretopics.vue?vue&type=style&index=0&id=0a8a4820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a4820",
  null
  
)

export default component.exports